import { render, staticRenderFns } from "./rezervasyonliste.vue?vue&type=template&id=adf833b4&"
import script from "./rezervasyonliste.vue?vue&type=script&lang=js&"
export * from "./rezervasyonliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports